export default "__VITE_ASSET__B_wrpL4F__"